import React from 'react'
import { FeaturedProdutos, Hero, Services, Contact } from '../components'

const HomePage = () => {
  return (
    <main>
      <Hero />
      <FeaturedProdutos />
      <Services />
      <Contact />
        <center><h4>Faça seu orçamento sem compromisso</h4></center>
    </main>
  )
}

export default HomePage
